import {
    CHANGE_TIMEZONE_OPEN_MODAL,
    CHANGE_TIMEZONE_CLOSE_MODAL,
    CHANGE_TIMEZONE_UPDATE_REQUEST,
    CHANGE_TIMEZONE_UPDATE_RESULT,
    CHANGE_TIMEZONE_SET_DEVICES,
} from 'Redux/actionTypes';

export const changeTimezoneSetDevices = (data) => ({
    type: CHANGE_TIMEZONE_SET_DEVICES,
    payload: data,
})

export const changeTimezoneOpenModal = (data) => ({
    type: CHANGE_TIMEZONE_OPEN_MODAL,
    payload: data,
})

export const changeTimezoneCloseModal = () => ({
    type: CHANGE_TIMEZONE_CLOSE_MODAL
})

export const changeTimezoneUpdateRequest = (data) => ({
    type: CHANGE_TIMEZONE_UPDATE_REQUEST,
    payload: data,
})

export const changeTimezoneUpdateResult = (result) => ({
    type: CHANGE_TIMEZONE_UPDATE_RESULT,
    payload: result,
})
